import React from "react";
import { PrinterIcon } from "@heroicons/react/24/outline";

const PrintButton = ({
  type = "button",
  onClick,
  label = "Print",
  className = "",
  disabled = false,
  size = "md",
  referance,
  onKeyDown,
  showIcon = true,
  ...rest
}) => {
  const sizeClasses = {
    xs: "px-2 py-0.5 text-xs",
    sm: "px-2.5 py-1 text-sm",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  const iconSizeClasses = {
    xs: "h-3.5 w-3.5",
    sm: "h-4 w-4",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };

  const finalClass = !disabled
    ? `
        bg-red-600 hover:bg-red-700 text-white
        ${sizeClasses[size]}
        ${className}
        flex items-center justify-center
        rounded transition-all duration-300 hover:shadow-md font-medium
      `
    : `
        ${sizeClasses[size]}
        rounded bg-gray-400 text-white
        flex items-center justify-center cursor-not-allowed
      `;

  const hasLabel = label !== undefined && label !== null && label !== "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={finalClass.trim()}
      ref={referance}
      onKeyDown={onKeyDown}
      {...rest}
    >
      {showIcon && (
        <span className={hasLabel ? "mr-2" : ""}>
          <PrinterIcon className={iconSizeClasses[size]} aria-hidden="true" />
        </span>
      )}
      {hasLabel && <span>{label}</span>}
    </button>
  );
};

export default PrintButton;
